import { defineMessages } from 'react-intl';

export default defineMessages({
    policies: {
        id: 'gateway.views.policy-landing.Policies',
        defaultMessage: 'Policies',
    },
    recentlyIssuedPolicyForPastXDays: {
        id: 'gateway.views.Recently Issued Policies for past x days',
        defaultMessage: 'Recently Issued Policies for past {value} days',
    },
    recentlyViewedPolicies: {
        id: 'gateway.views.policy-landing.RecentlyViewedPolicies',
        defaultMessage: 'Recently Viewed Policies',
    },
    recentlyViewed: {
        id: 'gateway.views.policy-landing.Recently Viewed',
        defaultMessage: 'Recently Viewed',
    },
    recentlyIssued: {
        id: 'gateway.views.policy-landing.Recently Issued',
        defaultMessage: 'Recently Issued',
    },
    delinquent: {
        id: 'gateway.views.policy-landing.Delinquent',
        defaultMessage: 'Billing Delinquent',
    },
    delinquentPolicies: {
        id: 'gateway.views.policy-landing.Delinquent Policies',
        defaultMessage: 'Delinquent Policies',
    },
    openQuotes: {
        id: 'gateway.views.policy-landing.Open Quotes',
        defaultMessage: 'Open Quotes',
    },
    openChanges: {
        id: 'gateway.views.policy-landing.Open Changes',
        defaultMessage: 'Open Changes',
    },
    openCancellations: {
        id: 'gateway.views.policy-landing.Open Cancellations',
        defaultMessage: 'Open Cancellations',
    },
    openRenewals: {
        id: 'gateway.views.policy-landing.Open Renewals',
        defaultMessage: 'Open Renewals',
    },
    product: {
        id: 'gateway.views.policy-landing.Product',
        defaultMessage: 'PRODUCT',
    },
    status: {
        id: 'gateway.views.policy-landing.Status',
        defaultMessage: 'STATUS',
    },
    policyNumber: {
        id: 'gateway.views.policy-landing.PolicyNumber',
        defaultMessage: 'POLICY NUMBER',
    },
    account: {
        id: 'gateway.views.policy-landing.Account',
        defaultMessage: 'ACCOUNT',
    },
    namedInsured: {
        id: 'gateway.views.policy-landing.NamedInsured',
        defaultMessage: 'Named Insured',
    },
    inGoodStanding: {
        id: 'gateway.views.policy-landing.In Good Standing',
        defaultMessage: 'In Good Standing',
    },
    billingStatus: {
        id: 'gateway.views.policy-landing.Billing Status',
        defaultMessage: 'Billing Status',
    },
    policyLandingQuotes: {
        id: 'gateway.views.policy-landing.Quotes',
        defaultMessage: 'Quotes',
    },
    policyLandingRenewal: {
        id: 'gateway.views.policy-landing.Renewal',
        defaultMessage: 'Renewal',
    },
    policyLandingChange: {
        id: 'gateway.views.policy-landing.Change',
        defaultMessage: 'Change',
    },
    policyLandingCancellation: {
        id: 'gateway.views.policy-landing.Cancellation',
        defaultMessage: 'Cancellation',
    },
    quickFilter: {
        id: 'gateway.views.policy-landing.Quick Filters',
        defaultMessage: 'Quick Filters',
    },
    advancedFilter: {
        id: 'gateway.views.policy-landing.Advanced Filter',
        defaultMessage: 'Advanced Filter',
    },
    switchTo: {
        id: 'gateway.views.policy-landing.Switch to',
        defaultMessage: 'Switch to',
    },
    premium: {
        id: 'gateway.views.policy-landing.Premium',
        defaultMessage: 'PREMIUM',
    },
    created: {
        id: 'gateway.views.policy-landing.Created',
        defaultMessage: 'CREATED',
    },
    jobNumber: {
        id: 'gateway.views.policy-landing.JobNumber',
        defaultMessage: 'TRANSACTION #',
    },
    jobStatus: {
        id: 'gateway.views.policy-landing.Job Status',
        defaultMessage: 'STATUS',
    },
    quotes: {
        id: 'gateway.views.policy-landing.Quotes',
        defaultMessage: 'Quotes',
    },
    renewal: {
        id: 'gateway.views.policy-landing.Renewal',
        defaultMessage: 'Renewal',
    },
    change: {
        id: 'gateway.views.policy-landing.Change',
        defaultMessage: 'Change',
    },
    accountTableHeading: {
        id: 'gateway.views.for past x days',
        defaultMessage: '{currentView} for past {value} days',
    },
    noResultsFound: {
        id: 'gateway.views.policy-landing.No results found for this filter',
        defaultMessage: 'No results were found for this filter.',
    },
    effectiveDate: {
        id: 'gateway.views.policy-landing.Effective Date',
        defaultMessage: 'Effective Date',
    },
    expirationDate: {
        id: 'gateway.views.POLICY EXIPIRATION DATE',
        defaultMessage: 'POLICY EXIPIRATION DATE',
    },
    accountNavigation: {
        id: 'gateway.navigation.breadcrumbs.Account: link',
        defaultMessage: 'Account: {link}',
    },
    requalificationRenewals: {
        id: 'gateway.views.policy-landing.requalificationRenewals',
        defaultMessage: 'Requalification Renewals',
    },
    commercial: {
        id: 'gateway.views.policy-landing.commercial',
        defaultMessage: 'Commercial',
    },
    residential: {
        id: 'gateway.views.policy-landing.residential',
        defaultMessage: 'Residential',
    },
    requalPending: {
        id: 'gateway.views.policy-landing.pendingmessage',
        defaultMessage: 'Pending Requalification',
    },
    requalified: {
        id: 'gateway.views.policy-landing.requalified',
        defaultMessage: 'Requalified',
    }
});
